"use client";

import type { FC, Ref } from "react";
import { WinningBidCard, type WinningBidCardProps } from "@huub-web/shared";

import type { TemplateCollection } from "../../types";
import { TemplatesParser } from "../../components";

export interface WinningBidTemplateProps {
  title?: WinningBidCardProps["title"];
  templates?: TemplateCollection;
}

/**
 * A template for displaying winning bid information.
 * @deprecated
 */
export const WinningBidTemplate: FC<
  WinningBidTemplateProps & { ref?: Ref<HTMLDivElement> }
> = ({ templates, ref, ...props }) => (
  <WinningBidCard ref={ref} {...props}>
    {templates && templates.length > 0 && (
      <TemplatesParser templates={templates} level={1} />
    )}
  </WinningBidCard>
);
